// src/utils/windStore.js
// =====================  WHERE THIS GOES  =====================
// New file. Twin of sunPathStore.js. Bridges the right-pane WindPanel
// and the Three.js wind controller in Site3DView. Panel writes params +
// reads results/status/rose; Site3DView registers the scene controller.
// Neither imports the other. Kept as a SEPARATE store (not merged into a
// shared climate store) to mirror the proven Sun Path pattern 1:1 — a
// shared store is a clean refactor once a third tool lands.
//
// `dir` is the FROM bearing (met convention). `mode` is 'static' | 'dynamic'.
// ============================================================

import { useEffect, useReducer } from 'react';

const state = {
  params: {
    month: 0,                 // Jan
    dir: 225, speed: 3.0,     // SW @ 3 m/s — sane default so the tool works offline
    mode: 'static',
    manual: true,             // true until a rose is fetched/applied
    lat: 22.31, lng: 73.18,
    showArrow: true, showRays: true, showTint: true, showParticles: true, showTurbine: false,
  },
  rose: null,                 // { source, perMonth:[{month,prevailingDir,meanSpeed}], annual }
  results: null,              // { totals, roles, hi, lo, dir, speed, dirCard, month }
  status: { hasMassing: false, hasContext: false },
};

let updater = null, analyzer = null, activator = null;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

export const getParams = () => state.params;
export const getResults = () => state.results;
export const getStatus = () => state.status;
export const getRose = () => state.rose;

export function setParams(patch) {
  state.params = { ...state.params, ...patch };
  if (updater) { try { updater(state.params); } catch (e) { console.warn('[wind] update', e); } }
  emit();
}
export function setResults(r) { state.results = r; emit(); }
export function setStatus(s) { state.status = { ...state.status, ...s }; emit(); }
export function setRose(r) { state.rose = r; emit(); }

// Site3DView calls this once its controller exists.
export function registerScene({ update, analyze, setActive }) {
  updater = update || null; analyzer = analyze || null; activator = setActive || null;
}
export function clearScene() { updater = analyzer = activator = null; }

export function activate() { if (activator) activator(true); if (updater) updater(state.params); }
export function deactivate() { if (activator) activator(false); }

export function runAnalysis() {
  if (!analyzer) return null;
  const t = analyzer(state.params);
  setResults(t);
  return t;
}

export function useWind() {
  const [, force] = useReducer((x) => x + 1, 0);
  useEffect(() => { listeners.add(force); return () => listeners.delete(force); }, []);
  return {
    params: state.params, results: state.results, status: state.status, rose: state.rose,
    setParams, setRose, runAnalysis, activate, deactivate,
    hasScene: !!analyzer,
  };
}
